(function (app) {
    app.provider("carrierDataApi", [function () {
        this.$get = ["dataFeedApiGateway", function (dataFeedApiGateway) {
            var service = {};

            // GETS
            service.getDataFlow = function () {
                return dataFeedApiGateway.get("/MappedCarrierData/GetAll");
            };

            return service;
        }];
    }]);
})(window.app);
